import type { Release } from '../../../types';

const arc: Release = {
  name: 'arc',
  short_description: 'Minimalist Ambient & Field Recording EP',
  description:
    "Arc is a ambient electronic EP built on delicate analog synthesis, tactile field recordings, and gentle melodic progressions. Across 'kindle', 'blossoms green', 'concret', 'light follows', and 'develop', joev creates an immersive, soothing sonic space that rewards deep listening.",
  tracklist: [
    {
      trackname: 'kindle',
      duration: '02:46 min',
      tracknr: '01',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/kindle',
      },
    },
    {
      trackname: 'blossoms green',
      duration: '04:16 min',
      tracknr: '02',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/blossoms-green',
      },
    },
    {
      trackname: 'concret',
      duration: '03:20 min',
      tracknr: '03',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/concret',
      },
    },
    {
      trackname: 'light follows',
      duration: '04:56 min',
      tracknr: '04',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/light-follows',
      },
    },
    {
      trackname: 'develop',
      duration: '06:00 min',
      tracknr: '05',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/develop',
      },
    },
  ],
  date: '02-2013',
  bgColor: '#d8c9af',
  cover: 'joevnoise_arc.png',
  detail_link: 'arc',
  links: [
    {
      bandcamp: 'https://joev.bandcamp.com/album/arc-ep',
    },
    {
      soundcloud: 'https://soundcloud.com/joevnoise/sets/arc-ep',
    },
  ],
};

export default arc;
